'use strict';

const formHelper = require('../../rituals-form-helper'),
    isSmallView = require('../../modules/helpers/isSmallView');

function handlePostalCompleted(postalCode, e) {

    const $postalCodeElement = $(e.target);

    const $shippingForm = $postalCodeElement.parents('form');
    const $continueBtn = $shippingForm.find('button[type=submit]');

    const validator = $shippingForm.validate();
    if (!$postalCodeElement.valid()) {
        return;
    }

    const $select = $('.js_delivery_date_select').find('.js-custom-select');
    $continueBtn.prop('disabled', true);
    step1ButtonLoading(true);

    $.ajax({
        type: 'GET',
        url: Urls.validatePostalCodeAndGetShippingOptions,
        data: {postalCode: postalCode, shouldGetNewOptions: $select.length > 0},
        success: function(data) {
            if (data.ok) {
                hidePostalCodeErrors($postalCodeElement, $continueBtn, $postalCodeElement.prev('.js-validator-error'));
                updateHomeDeliveryOptions(data, $select);
                return;
            }

            if (data.errorMessage) {
                exports.showPostalCodeErrors($postalCodeElement, $continueBtn, validator, data.errorMessage);
            }

            if (data.location) {
                $continueBtn.data('redirecto', data.location);
            }
        },
        complete: function() {
            if ($select.length > 0) {
                $select.selectric();
                if (!isSmallView()) {
                    $select.attr('tabindex', '-1');
                }
            }
            $continueBtn.removeAttr('disabled');
            step1ButtonLoading(false);
        }
    });
}

function hidePostalCodeErrors(postalCodeElement, continueBtn, errorElement) {
    continueBtn.removeData('redirecto');
    continueBtn.removeData('prevent-submit');
    postalCodeElement.removeData('prevent-automatic-validation');
    postalCodeElement.removeClass('excludedpostalerror');
    postalCodeElement.removeClass('dangerouspostal');
    postalCodeElement.removeClass('error');
    postalCodeElement.removeClass('js-validator-error');
    postalCodeElement.removeClass('js-warn-addded');
    continueBtn.off('click.invalidPostalCode');
    errorElement.remove();
}

function updateHomeDeliveryOptions(data, select) {
    if (data.result && select.length) {
        select.empty();
        const newOptions = data.result;
        const previousSelectedOption = data.selectedDeliveryOption;
        $.each(newOptions.delivery, function(key, value) {
            select.append($('<option></option>').attr('value', value.id).attr('selected', (previousSelectedOption && previousSelectedOption.id === value.id)).text(value.fullDisplayName));
        });
        $('.js_delivery_date_select').removeClass('hide');
        return;
    }

    if (select.length) {
        $('.js_delivery_date_select').addClass('hide');
    }
    return;
}

function step1ButtonLoading(turnOn) {
    const $step1ContinueButton = $('.js-step-1-continue-btn');
    const $spinnerStep1 = $('.js-step-1-spinner');

    $step1ContinueButton.toggleClass('button-loading', turnOn);
    $('.js-checkout-sticky-button').toggleClass('button-loading', turnOn);
    $spinnerStep1.parent().toggleClass('button-loading', turnOn);
    $spinnerStep1.toggleClass('spinner-visible', turnOn);
}

exports.initSearchByPostalCode = function() {
    const postalOptions = {
        onComplete: handlePostalCompleted,
        selectOnFocus: true,
    };

    const $postalInput = $('input[name$=_singleshipping_shippingAddress_addressFields_postal]');
    formHelper.initPostalMask($postalInput, postalOptions);
    $postalInput.off('input.postalerror').on('input.postalerror', function() {
        const $postalCodeElement = $(this);
        hidePostalCodeErrors($postalCodeElement, $postalCodeElement.parents('form').find('button[type=submit]'), $postalCodeElement.prev('.js-validator-error'));
    });

    $(document).off('shippingPostalCode.updated').on('shippingPostalCode.updated', function(e, params) {
        if (!params || !params.length) {
            return;
        }
        const $elements = params.filter('input[name$=_singleshipping_shippingAddress_addressFields_postal]');
        if (!$elements || !$elements.length) {
            return;
        }

        const value = $elements.val();

        if (!value || !value.length) {
            return;
        }

        handlePostalCompleted(value, {'target':$elements});

    });
};

exports.showPostalCodeErrors = function (postalCodeElement, continueBtn, validator, errorMessage) {
    const errorObj = {};
    errorObj[postalCodeElement.attr('name')] = errorMessage;
    validator.showErrors(errorObj);
    postalCodeElement.addClass('excludedpostalerror');
    postalCodeElement.addClass('dangerouspostal');
    postalCodeElement.addClass('error');
    postalCodeElement.addClass('js-validator-error');
    postalCodeElement.addClass('js-warn-addded');

    continueBtn.data('prevent-submit', true);
    postalCodeElement.data('prevent-automatic-validation', true);
    continueBtn.on('click.invalidPostalCode', function(evt){
        evt.preventDefault();
        formHelper.scrollToInputField(postalCodeElement);
        postalCodeElement.focus();
    });
};
